<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>员工管理</el-breadcrumb-item>
      <el-breadcrumb-item>员工档案</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="display: flex;justify-content: space-between">
      <div style="width: 20%">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree
            :data="orgList"
            :props="treeProps"
            :highlight-current="true"
            node-key="id"
            :filter-node-method="filterNode"
            @node-click="handleCheckChange"
            ref="tree">
          </el-tree>
        </div>
      </div>
      <div style="width: 20%">
        <el-input v-model="searchText" size="mini" style="width: 75%"></el-input>
        <el-button size="mini"  @click="loadUser" style="width: 20%">查询</el-button>
        <el-table :data="userList" fit border stripe="stripe"
                  height="700px"
                  :header-cell-style="{background:'#eff3f8', color:'#333', padding: '5px'}"
                  :row-style="{height: '0'}"
                  @row-click="selectUser">
          <el-table-column
            align="center"
            prop="orgName"
            v-if="selectOrg.level < 3"
            label="所属门店">
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            v-if="selectOrg.level < 3"
            label="员工名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            v-if="selectOrg.level == 3"
            label="员工名称">
          </el-table-column>
        </el-table>
      </div>
      <div style="width: 60%">
      <div style="rgb(222,222,222);width: 100%;height: 600px;background-color: #eff3f8">
        <div style="width: 100%;display: flex;justify-content: center">
          <span style="color: #f78989;font-size: 18px">员工档案</span>
        </div>
        <span style="color: #8cc5ff;font-size: 14px">基本信息</span>
        <el-card>
          <div style="width: 100%;display: flex;justify-content: space-around">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">员工姓名：</span>
              <el-input v-model="userCard.userName" readonly
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">员工电话：</span>
              <el-input v-model="userCard.userPhone" readonly
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around; margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">身份证号：</span>
              <el-input v-model="userCard.idNum"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">出生日期：</span>
              <el-date-picker
                v-model="userCard.birthday"
                type="date"
                size="mini"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
<!--              <el-input v-model="userCard.birthday"-->
<!--                        size="mini" style="width: 50%;"></el-input>-->
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around; margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">部门：</span>
              <el-input v-model="userCard.shopName"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">工号：</span>
              <el-input v-model="userCard.userCode"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around; margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">年龄：</span>
              <el-input v-model="userCard.age"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">民族：</span>
              <el-input v-model="userCard.nation"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around; margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">性别：</span>
              <el-input v-model="userCard.sex"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">职位：</span>
              <el-select v-model="userCard.position" size="mini" style="width: 50%;" placeholder="请选择">
                <el-option
                  v-for="item in cardZwList"
                  :key="item.zwEnName"
                  :label="item.zwCnName"
                  :value="item.zwCnName">
                </el-option>
              </el-select>
<!--              <el-input v-model="userCard.position"-->
<!--                        size="mini" style="width: 50%;"></el-input>-->
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around; margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">座机：</span>
              <el-input v-model="userCard.telephone"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">邮箱：</span>
              <el-input v-model="userCard.email"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-between; margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">家庭住址：</span>
              <el-input v-model="userCard.address"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">婚姻状况：</span>
              <el-input v-model="userCard.marital"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around; margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">政治面貌：</span>
              <el-input v-model="userCard.politics"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">户籍类别：</span>
              <el-select v-model="userCard.census" size="mini" style="width: 50%;" placeholder="请选择">
                <el-option
                  v-for="item in censusList"
                  :key="item.index"
                  :label="item.value"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </el-card>
        <span style="color: #8cc5ff;font-size: 14px">健康信息</span>
        <el-card>
          <div style="width: 100%;display: flex;justify-content: space-around">
            <div style="width: 30%">
              <span style="color: #8c939d;font-size: 14px">身高：</span>
              <el-input v-model="userCard.height"
                        size="mini" style="width: 50%;"></el-input><span style="color: #8c939d;font-size: 14px">cm</span>
            </div>
            <div style="width: 30%">
              <span style="color: #8c939d;font-size: 14px">体重：</span>
              <el-input v-model="userCard.weight"
                        size="mini" style="width: 50%;"></el-input><span style="color: #8c939d;font-size: 14px">kg</span>
            </div>
            <div style="width: 30%">
              <span style="color: #8c939d;font-size: 14px">服装尺码：</span>
              <el-input v-model="userCard.dressSize"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 30%">
              <span style="color: #8c939d;font-size: 14px">鞋子尺码：</span>
              <el-input v-model="userCard.shoeSize"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
        </el-card>
        <span style="color: #8cc5ff;font-size: 14px">教育信息</span>
        <el-card>
          <div style="width: 100%;display: flex;justify-content: space-around">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">学历：</span>
              <el-input v-model="userCard.education"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">专业：</span>
              <el-input v-model="userCard.specialty"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around;margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">毕业学校：</span>
              <el-input v-model="userCard.school"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">毕业时间：</span>
              <el-date-picker
                v-model="userCard.leaveSchoolTime"
                type="date"
                size="mini"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
<!--              <el-input v-model="userCard.leaveSchoolTime"-->
<!--                        size="mini" style="width: 50%;"></el-input>-->
            </div>
          </div>
        </el-card>
        <span style="color: #8cc5ff;font-size: 14px">银行信息</span>
        <el-card>
          <div style="width: 100%;display: flex;justify-content: space-around">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">银行卡号：</span>
              <el-input v-model="userCard.cardNo"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">开户行：</span>
              <el-input v-model="userCard.bank"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around;margin-top: 20px">
            <div style="width: 100%">
              <span style="color: #8c939d;font-size: 14px">开户名：</span>
              <el-input v-model="userCard.bankUserName"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
        </el-card>
        <span style="color: #8cc5ff;font-size: 14px">合同信息</span>
        <el-card>
          <div style="width: 100%;display: flex;justify-content: space-around">
            <div style="width: 30%">
              <span style="color: #8c939d;font-size: 14px">合同开始时间：</span>
              <el-date-picker
                v-model="userCard.contractStartDate"
                type="date"
                size="mini"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
<!--              <el-input v-model="userCard.contractStartDate"-->
<!--                        size="mini" style="width: 50%;"></el-input>-->
            </div>
            <div style="width: 30%">
              <span style="color: #8c939d;font-size: 14px">合同结束时间：</span>
              <el-date-picker
                v-model="userCard.contractEndDate"
                type="date"
                size="mini"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
<!--              <el-input v-model="userCard.contractEndDate"-->
<!--                        size="mini" style="width: 50%;"></el-input>-->
            </div>
          </div>
        </el-card>
        <span style="color: #8cc5ff;font-size: 14px">其他信息</span>
        <el-card>
          <div style="width: 100%;display: flex;justify-content: space-around">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">入职时间：</span>
              <el-date-picker
                v-model="userCard.entryTime"
                type="date"
                size="mini"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
<!--              <el-input v-model="userCard.entryTime"-->
<!--                        size="mini" style="width: 50%;"></el-input>-->
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">介绍人：</span>
              <el-input v-model="userCard.introducer"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around;margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">紧急联系人：</span>
              <el-input v-model="userCard.emergencyContact"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">紧急联系人电话：</span>
              <el-input v-model="userCard.emergencyContactPhone"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px">
            <span style="color: #8c939d;font-size: 14px">工作简历：</span>
            <el-input v-model="userCard.resume" type="textarea"
                      size="mini" style="width: 90%;"></el-input>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px">
            <span style="color: #8c939d;font-size: 14px">人生感言：</span>
            <el-input v-model="userCard.lifeTestimonial" type="textarea"
                      size="mini" style="width: 90%;"></el-input>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px">
              <span style="color: #8c939d;font-size: 14px">参与过的培训：</span>
              <el-input v-model="userCard.train" type="textarea"
                        size="mini" style="width: 90%;"></el-input>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px">
              <span style="color: #8c939d;font-size: 14px">加入朋朋原因：</span>
              <el-input v-model="userCard.reason" type="textarea"
                        size="mini" style="width: 90%;"></el-input>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px">
              <span style="color: #8c939d;font-size: 14px">企业内部荣誉：</span>
              <el-input v-model="userCard.inHonor" type="textarea"
                        size="mini" style="width: 90%;"></el-input>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px">
              <span style="color: #8c939d;font-size: 14px">政府机构荣誉：</span>
              <el-input v-model="userCard.govHonor" type="textarea"
                        size="mini" style="width: 90%;"></el-input>
          </div>
        </el-card>
        <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
          <span style="color: #8cc5ff;font-size: 14px">家庭成员</span>
          <el-button size="mini"  @click="addRow">添加一行</el-button>
        </div>
        <el-card>
          <el-form>
            <el-table :data="familyList" fit border stripe="stripe"
                      :cell-style="{padding: '5px'}"
                      :header-cell-style="{background:'#eff3f8', color:'#333', padding: '5px'}"
                      :row-style="{height: '0'}">
              <el-table-column
                align="center"
                label="操作" >
                <template slot-scope="scope">
                  <el-link type="danger" icon="el-icon-delete"
                           @click="deleteRow(scope.row, scope.$index)"></el-link>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="家人姓名" >
                <template slot-scope="scope">
                  <el-form-item
                    size="mini" style="margin-bottom: 0"
                    :prop="'familyList.' + scope.$index + '.familyName'"
                  >
                    <el-input size="mini" v-model="scope.row.familyName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="家人电话" >
                <template slot-scope="scope">
                  <el-form-item
                    size="mini" style="margin-bottom: 0"
                    :prop="'familyList.' + scope.$index + '.familyPhone'"
                  >
                    <el-input size="mini" v-model="scope.row.familyPhone"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="从属关系" >
                <template slot-scope="scope">
                  <el-form-item
                    size="mini" style="margin-bottom: 0"
                    :prop="'familyList.' + scope.$index + '.familyRelation'"
                  >
                    <el-input size="mini" v-model="scope.row.familyRelation"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </el-card>
        <el-button size="mini" :disabled="isNew == false"  @click="createCard">创建</el-button>
        <el-button size="mini" :disabled="isNew == true" @click="editCard">修改</el-button>
      </div>
      </div>

      <el-dialog
        title="员工列表"
        :visible.sync="userDialogVisible"
        width="60%"
        :close-on-click-modal="false"
      >
        <el-table :data="userList" fit border stripe="stripe"
                  height="300px" :cell-style="{padding: '5px'}"
                  :header-cell-style="{background:'#eff3f8', color:'#333', padding: '5px'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            label="操作" width="160">
            <template slot-scope="scope">
              <el-radio :label="scope.$index" v-model="selectUserId"
                        @change.native="selectUser(scope.row)">{{''}}</el-radio>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            label="员工名称" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="员工电话" >
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      orgId:'',
      userId:'',
      orgList: [],
      userList: [],
      selectUserId:'',
      selectOrg:'',
      selectedUser:'',
      filterText: '',
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      userDialogVisible:false,
      userCard:{
        userId:'',
        userName:'',
        userPhone:'',
        shopName:'',
        idNum:'',
        birthday:'',
        userCode:'',
        age:'',
        nation:'',
        sex:'',
        position:'',
        telephone:'',
        email:'',
        address:'',
        marital:'',
        politics:'',
        census:'',
        height:'',
        weight:'',
        dressSize:'',
        shoeSize:'',
        education:'',
        specialty:'',
        school:'',
        leaveSchoolTime:'',
        cardNo:'',
        bank:'',
        bankUserName:'',
        introducer:'',
        entryTime:'',
        emergencyContact:'',
        emergencyContactPhone:'',
        lifeTestimonial:'',
        train:'',
        reason:'',
        inHonor:'',
        govHonor:'',
        resume:'',
        contractStartDate:'',
        contractEndDate:'',
        familyList:[]
      },
      familyList:[],
      family:{
        familyName: '',
        familyPhone: '',
        familyRelation: '',
      },
      isNew:false,
      censusList:[
        {index:1, value:'农业户口'},
        {index:2, value:'城镇户口'}
      ],
      searchText:'',
      cardZwList:[
        {zwEnName:'js', zwCnName:'技师'},
        {zwEnName:'dz', zwCnName:'店长'},
        {zwEnName:'bz', zwCnName:'部长'},
        {zwEnName:'fbz', zwCnName:'副部长'},
        {zwEnName:'gs', zwCnName:'干事'},
        {zwEnName:'jl', zwCnName:'经理'},
      ],
    }
  },
  methods:{
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    //组织机构树点击节点方法
    handleCheckChange(data) {
      this.selectOrg = data;
      this.selectUserId = '';
      this.loadUser(data);
      // this.showUserDialog();
    },
    // 加载机构树
    async loadOrg(){
      const {data:res} = await this.$http.get(`orgList/orgId/${this.orgId}`);
      this.orgList = [res.data];
    },
    async loadUser(){
      if (this.selectOrg !== '' && this.selectOrg.level == 3){
        const {data:res} = await this.$http.get(`/org/users/${this.selectOrg.id}`);
        this.userList = res.data;
      } else {
        const {data:res} = await this.$http.post('/load/org/employee',{areaId: this.selectOrg.id,
          searchText: this.searchText});
        this.userList = res.data;
      }
    },
    async selectUser(row){
      this.clear();
      this.selectedUser = row;
      this.userCard.userId = row.id;
      this.userCard.userName = row.userName;
      this.userCard.userPhone = row.phone;
      await this.loadUserCard(row.id);
      this.closeUserDialog();
    },
    async loadUserCard(data){
      const {data:res} = await this.$http.get(`/load/user/card/${data}`);
      if (res.data == null){
        this.isNew = true;
      } else {
        this.isNew = false;
        this.userCard = res.data;
        this.familyList = res.data.familyList;
      }
    },
    showUserDialog(){
      this.userDialogVisible = true;
    },
    closeUserDialog(){
      this.userDialogVisible = false;
    },
    addRow(){
      const item = {
        familyName: '',
        familyPhone: '',
        familyRelation: ''
      }
      this.familyList.push(item);
    },
    deleteRow(row, index){
      this.familyList.splice(index, 1);
    },
    async createCard(){
      this.userCard.familyList = this.familyList;
      const {data:res} = await this.$http.post(`/new/user/card`, this.userCard);
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
      this.$router.go(0)
    },
    async editCard(){
      this.userCard.familyList = this.familyList;
      const {data:res} = await this.$http.post(`/edit/user/card`, this.userCard);
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
      this.$router.go(0)
    },
    clear(){
      this.userCard.userId = '';
      this.userCard.userName = '';
      this.userCard.userPhone = '';
      this.userCard.shopName = '';
      this.userCard.idNum = '';
      this.userCard.birthday = '';
      this.userCard.userCode = '';
      this.userCard.age = '';
      this.userCard.nation = '';
      this.userCard.sex = '';
      this.userCard.position = '';
      this.userCard.telephone = '';
      this.userCard.email = '';
      this.userCard.address = '';
      this.userCard.marital = '';
      this.userCard.politics = '';
      this.userCard.census = '';
      this.userCard.height = '';
      this.userCard.weight = '';
      this.userCard.dressSize = '';
      this.userCard.shoeSize = '';
      this.userCard.education = '';
      this.userCard.specialty = '';
      this.userCard.school = '';
      this.userCard.leaveSchoolTime = '';
      this.userCard.cardNo = '';
      this.userCard.bank = '';
      this.userCard.bankUserName = '';
      this.userCard.introducer = '';
      this.userCard.entryTime = '';
      this.userCard.emergencyContact = '';
      this.userCard.emergencyContactPhone = '';
      this.userCard.lifeTestimonial = '';
      this.userCard.train = '';
      this.userCard.lifeTestimonial = '';
      this.userCard.reason = '';
      this.userCard.inHonor = '';
      this.userCard.govHonor = '';
      this.userCard.resume = '';
      this.userCard.contractStartDate = '';
      this.userCard.contractEndDate = '';
      this.userCard.familyList = [];
      this.familyList = [];
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  //align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}

.left_con{
  //display: flex;
  //justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: 100px;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  //flex: 1;
  width: 800px;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/UserCard.vue